import { render, staticRenderFns } from "./alert_dialog.vue?vue&type=template&id=2e6b6591&scoped=true&"
import script from "./alert_dialog.vue?vue&type=script&lang=js&"
export * from "./alert_dialog.vue?vue&type=script&lang=js&"
import style0 from "./alert_dialog.vue?vue&type=style&index=0&id=2e6b6591&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6b6591",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
